package amazon.lastmile.inject

import app.nestbridge.app.ui.AuthenticationUiFactory
import com.slack.circuit.runtime.ui.Ui
import me.tatarka.inject.annotations.IntoSet
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = AuthenticationUiFactory::class)
public interface AppNestbridgeAppUiAuthenticationUiFactory {
  @Provides
  @IntoSet
  public fun provideAuthenticationUiFactoryFactoryMultibinding(authenticationUiFactory: AuthenticationUiFactory): Ui.Factory = authenticationUiFactory
}
